/**
 * Earnings API — mirrors `cargoEarnings.js`. Driver-perspective by default.
 */
import { api } from './client';

export interface EarningEntry {
  id: number;
  shipment_id?: number;
  trip_id?: number;
  amount: number;
  currency: string;
  status: 'pending' | 'released';
  description?: string;
  created_at: string;
  released_at?: string;
}

export interface EarningsSummary {
  by_currency: Array<{ currency: string; total: number; pending: number; released: number }>;
  total_shipments?: number;
}

function unwrap<T>(res: { data?: any }): T {
  return (res.data?.data ?? res.data) as T;
}

export const earningsApi = {
  async list(opts: { status?: 'pending' | 'released'; page?: number; limit?: number } = {}): Promise<EarningEntry[]> {
    const r = await api.get(`/api/cargo/earnings`, { params: opts });
    return unwrap<EarningEntry[]>(r);
  },
  async summary(as: 'driver' | 'sender' | 'receiver' | 'center' = 'driver', centerId?: number): Promise<EarningsSummary> {
    const r = await api.get(`/api/cargo/earnings/summary`, { params: { as, centerId } });
    return unwrap<EarningsSummary>(r);
  },
  async ledger(opts: { as?: 'driver' | 'center'; centerId?: number; limit?: number; offset?: number } = {}): Promise<EarningEntry[]> {
    const r = await api.get(`/api/cargo/earnings/ledger`, { params: opts });
    return unwrap<EarningEntry[]>(r);
  },
};
